import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { DoughnutChartColors } from './DoughnutChart'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface Props {
  labels: string[]
  data: number[]
}
const options = {
  indexAxis: 'y' as const,
  responsive: true,
  maintainAspectRatio: true,
  plugins: {
    tooltip: {
      enabled: true,
    },
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
        borderColor: 'white',
      },
      ticks: {
        display: false,
      },
    },
    y: {
      grid: {
        display: false,
        borderColor: 'white',
      },
      ticks: {
        display: true,
        color: '#000000DE',
        font: {
          size: 12,
          family: 'Roboto',
        },
      },
    },
  },
}

export default function LinearChart({ labels, data }: Props) {
  const completeData = {
    labels,
    datasets: [
      {
        data: data,
        backgroundColor: DoughnutChartColors,
        borderRadius: 55,
        categoryPercentage: 0.35,
        minBarLength: 10,
      },
    ],
  }
  return (
    <div>
      <Bar options={options} data={completeData} />
    </div>
  )
}
